/**
 * callFilters.js — Single source of truth for ALL call category definitions.
 * Every page MUST import from this file. No duplicate category logic anywhere.
 *
 * ╔═══════════════════════════════════════════════════════════════════╗
 * ║  LOCKED — DO NOT MODIFY THESE FILTER DEFINITIONS                ║
 * ║  Owner approval required before ANY changes.                    ║
 * ║  Locked by: User (Apr 1, 2026)                                 ║
 * ╚═══════════════════════════════════════════════════════════════════╝
 */

// Categories that count as "fake" (spam + dead)
export const FAKE_CATEGORIES = ["spam_call", "dead_call"];

// All problem categories (everything that isn't valid or pending)
export const PROBLEM_CATEGORIES = ["dead_call", "spam_call", "adult_call", "ivr_call", "non_us_accent", "buy_sell_intent"];

/**
 * Classify a single call: "valid" | "problem" | "pending"
 * Category is the ONLY source of truth.
 */
export function classifyCall(call) {
  const cat = call.category;
  if (cat === "valid_service_call") return "valid";
  if (PROBLEM_CATEGORIES.includes(cat)) return "problem";
  return "pending";
}

/**
 * Check if a call is fake (spam or dead)
 */
export function isFake(call) {
  return FAKE_CATEGORIES.includes(call.category);
}

/**
 * Count calls by category group. Used by Dashboard, Analytics, etc.
 * Returns { total, valid, fake, non_us, adult, ivr, buy_sell, pending }
 */
export function countByCategory(calls) {
  const stats = {
    total_calls: 0, valid_calls: 0, fake_calls: 0, non_us_calls: 0,
    adult_calls: 0, ivr_calls: 0, buy_sell_calls: 0, pending_calls: 0,
  };
  for (const call of calls) {
    stats.total_calls++;
    const cat = call.category;
    if (cat === "valid_service_call") stats.valid_calls++;
    else if (cat === "spam_call" || cat === "dead_call") stats.fake_calls++;
    else if (cat === "non_us_accent") stats.non_us_calls++;
    else if (cat === "adult_call") stats.adult_calls++;
    else if (cat === "ivr_call") stats.ivr_calls++;
    else if (cat === "buy_sell_intent") stats.buy_sell_calls++;
    else stats.pending_calls++;
  }
  return stats;
}
